
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { startDescartesXPlanilla } from "../../../services";






// export const useLoteDistriXID = (id) => {

//     const loteDistriXIDQuery = useQuery({
//         queryKey: ['distribucion-id', id], 
//         queryFn: () => startLoteDistriXID(id),
//     });

//     return {
//         loteDistriXIDQuery
//     }
// }



export const useDescartesXPlanilla = (id) => {
    const descartesXPlaniQuery = useQuery({
        queryKey: ['descartes-xplanilla', id], 
        queryFn: () => startDescartesXPlanilla(id),
    });

    return {
        descartesXPlaniQuery,
    }
}





// export const useDescuentosXTipo = ({id, descuento}) => {
    
//     const [page, setPage] = useState(0);
//     const [inicio, setInicio] = useState('');
//     const [final, setFinal] = useState('');

//     const desucentoTipoQuery = useQuery({
//         queryKey: ['descuento-tipo', { page, descuento, id, inicio, final }], 
//         queryFn: () => startDescuentosXTipo({ page, descuento, id, inicio, final }),
//     });
    

//     const chagePage = (num) => {
//         setPage(num - 1);
//     }

//     const chageInicio = (valor) => {
//         setPage(0);
//         setInicio(valor)
//     }

//     const chageFinal = (valor) => {
//         setPage(0);
//         setFinal(valor)
//     }

    
//     return {
//         // Estados
//         page,
//         inicio,
//         final,

//         // Metodos
//         chageInicio,
//         chageFinal,
//         chagePage,
//         desucentoTipoQuery,
//     }
// }


